import { createSlice } from '@reduxjs/toolkit';

const MerchantSlice = createSlice({
  name: 'MerchantSlice',
  initialState: {
    isLoading: false,
    isListlaoding: false,
    isViewLoading: false,
    merchantListData: [],
    listMerchants: [],
    isError: null,
    viewMerchantDetails: null,
    isGenerateLoading: false,
    locationIdData: null,
    isTemporaryCloseLoading: false,
    isMaintenanceLoading: false,
    isComingSoonLoading: false,
    isBulkHideLoading: false,
    isArchiveLoading: false,
    isBulkUploadLoading: false,
  },
  reducers: {
    /////// Merchant list for modal selecting merchnat start //////

    requestMerchantList: (state) => {
      return { ...state, isLoading: true };
    },
    responseMerchantList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isUpdatingStatusLoading: false,
        merchantListData: action?.payload?.data,
      };
    },
    failureMerchantList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
      };
    },

    ///////////////// Merchant List for listing table page of merchnat /////
    requestMerchantListPage: (state) => {
      return { ...state, isListlaoding: true };
    },
    responseMerchantListPage: (state, action) => {
      return {
        ...state,
        isListlaoding: false,
        isUpdatingStatusLoading: false,
        listMerchants: action?.payload?.data,
      };
    },
    failureMerchantListPage: (state, action) => {
      return {
        ...state,
        isListlaoding: false,
        isError: action?.payload,
      };
    },

    /////// Generate location ID //////
    requestGenerateLocationId: (state) => {
      return { ...state, isGenerateLoading: true };
    },
    responseGenerateLocationId: (state, action) => {
      return {
        ...state,
        isGenerateLoading: false,
        locationIdData: action?.payload,
      };
    },
    failureGenerateLocationId: (state, action) => {
      return { ...state, isGenerateLoading: false, isError: action?.payload };
    },

    /////// Merchant Add-Edit //////
    requestMerchantAdd: (state, action) => {
      return { ...state, isLoading: action?.payload ?? true };
    },
    responseMerchantAdd: (state, action) => {
      return {
        ...state,
        listMerchants: {
          ...state.listMerchants,
          list: state.listMerchants?.list?.map((merchant) =>
            merchant.merchantId === action?.payload?.data?.merchantId
              ? {
                  ...merchant,
                  inMaintenance: action?.payload?.data?.inMaintenance,
                }
              : merchant,
          ),
        },
        isLoading: false,
      };
    },
    failureMerchantAdd: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    ////////// Merchant View /////////
    requestMerchantView: (state) => {
      return { ...state, isViewLoading: true };
    },
    responseMerchantView: (state, action) => {
      return {
        ...state,
        isViewLoading: false,
        viewMerchantDetails: action.payload,
      };
    },
    failureMerchantView: (state, action) => {
      return { ...state, isViewLoading: false, isError: action?.payload };
    },

    ////// Merchant Delete ////
    requestMerchantDelete: (state) => {
      return { ...state, isLoading: true };
    },
    responseMerchantDelete: (state) => {
      return { ...state, isLoading: false };
    },
    failureMerchantDelete: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    ////// Sync Merchant Data ////
    requestSyncDataMerchant: (state) => {
      return { ...state, isSyncLoading: true };
    },
    responseSyncDataMerchant: (state) => {
      return { ...state, isSyncLoading: false };
    },
    failureSyncDataMerchant: (state, action) => {
      return { ...state, isSyncLoading: false, isError: action?.payload };
    },

    /////// Merchant Deactivate-Active //////
    requestMerchantDeactivate: (state) => {
      return { ...state, isUpdatingStatusLoading: true };
    },
    responseMerchantDeactivate: (state) => {
      return { ...state, isUpdatingStatusLoading: false };
    },
    failureMerchantDeactivate: (state, action) => {
      return {
        ...state,
        isUpdatingStatusLoading: false,
        isError: action?.payload,
      };
    },

    /////// Maintenance Mode //////
    requestMaintenanceMode: (state) => {
      return { ...state, isMaintenanceLoading: true };
    },
    responseMaintenanceMode: (state, action) => {
      const { merchantId, inMaintenance } = action?.payload?.data ?? {};
      return {
        ...state,
        isMaintenanceLoading: false,
        listMerchants: {
          ...state.listMerchants,
          list: state.listMerchants?.list?.map((merchant) =>
            merchant.merchantId === merchantId
              ? {
                  ...merchant,
                  inMaintenance,
                  ...(inMaintenance && {
                    isTemporarilyClosed: false,
                    isComingSoon: false,
                  }),
                }
              : merchant,
          ),
        },
      };
    },
    failureMaintenanceMode: (state, action) => {
      return {
        ...state,
        isMaintenanceLoading: false,
        isError: action?.payload,
      };
    },

    /////// Temporary Close Merchant //////
    requestTemporaryClose: (state) => {
      return { ...state, isTemporaryCloseLoading: true };
    },
    responseTemporaryClose: (state, action) => {
      const { merchantId, isTemporarilyClosed } = action?.payload?.data ?? {};
      return {
        ...state,
        isTemporaryCloseLoading: false,
        listMerchants: {
          ...state.listMerchants,
          list: state.listMerchants?.list?.map((merchant) =>
            merchant.merchantId === merchantId
              ? {
                  ...merchant,
                  isTemporarilyClosed,
                  ...(isTemporarilyClosed && {
                    inMaintenance: false,
                    isComingSoon: false,
                  }),
                }
              : merchant,
          ),
        },
      };
    },
    failureTemporaryClose: (state, action) => {
      return {
        ...state,
        isTemporaryCloseLoading: false,
        isError: action?.payload,
      };
    },

    /////// Coming Soon Mode //////
    requestComingSoonMode: (state) => {
      return { ...state, isComingSoonLoading: true };
    },
    responseComingSoonMode: (state, action) => {
      const { merchantId, isComingSoon } = action?.payload?.data ?? {};
      return {
        ...state,
        isComingSoonLoading: false,
        listMerchants: {
          ...state.listMerchants,
          list: state.listMerchants?.list?.map((merchant) =>
            merchant.merchantId === merchantId
              ? {
                  ...merchant,
                  isComingSoon,
                  ...(isComingSoon && {
                    inMaintenance: false,
                    isTemporarilyClosed: false,
                  }),
                }
              : merchant,
          ),
        },
      };
    },
    failureComingSoonMode: (state, action) => {
      return {
        ...state,
        isComingSoonLoading: false,
        isError: action?.payload,
      };
    },

    /////// Bulk Hide/Restore //////
    requestBulkHide: (state) => {
      return { ...state, isBulkHideLoading: true };
    },
    responseBulkHide: (state) => {
      return { ...state, isBulkHideLoading: false };
    },
    failureBulkHide: (state, action) => {
      return { ...state, isBulkHideLoading: false, isError: action?.payload };
    },

    /////// Archive/Restore Single Merchant //////
    requestArchiveMerchant: (state) => {
      return { ...state, isArchiveLoading: true };
    },
    responseArchiveMerchant: (state) => {
      return { ...state, isArchiveLoading: false };
    },
    failureArchiveMerchant: (state, action) => {
      return { ...state, isArchiveLoading: false, isError: action?.payload };
    },

    ////// Sync Merchant Sheet ////
    requestSyncMerchantSheet: (state) => {
      return { ...state, isMerchantSheetLoading: true };
    },
    responseSyncMerchantSheet: (state) => {
      return { ...state, isMerchantSheetLoading: false };
    },
    failureSyncMerchantSheet: (state, action) => {
      return {
        ...state,
        isMerchantSheetLoading: false,
        isError: action?.payload,
      };
    },

    ////// Bulk Upload Merchants ////
    requestBulkUpload: (state) => {
      return { ...state, isBulkUploadLoading: true };
    },
    responseBulkUpload: (state) => {
      return { ...state, isBulkUploadLoading: false };
    },
    failureBulkUpload: (state, action) => {
      return { ...state, isBulkUploadLoading: false, isError: action?.payload };
    },
  },
});

export const {
  failureMerchantList,
  responseMerchantList,
  requestMerchantList,
  failureMerchantAdd,
  requestMerchantAdd,
  responseMerchantAdd,
  failureMerchantView,
  requestMerchantView,
  responseMerchantView,
  failureMerchantDelete,
  requestMerchantDelete,
  responseMerchantDelete,
  requestSyncDataMerchant,
  responseSyncDataMerchant,
  failureSyncDataMerchant,
  failureMerchantDeactivate,
  requestMerchantDeactivate,
  responseMerchantDeactivate,
  failureMerchantListPage,
  requestMerchantListPage,
  responseMerchantListPage,
  failureGenerateLocationId,
  requestGenerateLocationId,
  responseGenerateLocationId,
  requestTemporaryClose,
  responseTemporaryClose,
  failureTemporaryClose,
  requestMaintenanceMode,
  responseMaintenanceMode,
  failureMaintenanceMode,
  requestComingSoonMode,
  responseComingSoonMode,
  failureComingSoonMode,
  requestSyncMerchantSheet,
  responseSyncMerchantSheet,
  failureSyncMerchantSheet,
  requestBulkHide,
  responseBulkHide,
  failureBulkHide,
  requestArchiveMerchant,
  responseArchiveMerchant,
  failureArchiveMerchant,
  requestBulkUpload,
  responseBulkUpload,
  failureBulkUpload,
} = MerchantSlice.actions;
export default MerchantSlice.reducer;
